module.exports = __webpack_public_path__ + "static/Jai-b7c5ab78bdcdfa0c00cd08c4aa93a055.jpg";